;(function() {
  'use strict'

  Controller.$inject = ["$state", "userService"];
  angular.module('app.signup').controller('Signup', Controller)

  /* @ngInject */
  function Controller($state, userService) {
    $state.go('app.public')

    if (!userService.loggedIn()) {
      userService.showSignup()
    }
  }
})()
